<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>

      <template v-slot:fileStatus="{ row }">
        <el-tag
          size="mini"
          :type="row.fileStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.fileStatusText }}
        </el-tag>
      </template>
      <template v-slot:displayCreateBy="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>

      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_tech_edit') || '编辑'"
          placement="top"
          v-show="!disabled"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'edit',
                code: row.amzSkuDocCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_tech_download') || '下载'"
          placement="top"
        >
          <i
            class="el-icon-download tool-btn"
            @click="downloadFile(row.fileCode)"
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_tech_del') || '删除'"
          placement="top"
          v-show="!disabled"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="del(row.amzSkuDocCode)"
          ></i>
        </el-tooltip>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l("INDEX.tips_no_data") || "暂无数据！" }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from "@/mixins/table-auto-height";
import tableColumns from "./table-columns.js";

export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
    },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => this.$emit("reload"),
        },
      },
      tableColumns: tableColumns(this),
    };
  },
  methods: {
    downloadFile(fileCode) {
      if (!fileCode) {
        this.$message.warning(this.$l("INDEX.tips_tech_no_file") || "文件不存在");
        return;
      }
      this.$api.SYS_FILEDOWNLOAD(fileCode);
    },
    del(code) {
      this.$confirm(
        this.$l("INDEX.tips_tech_delete") || "是否要删除该记录？",
        this.$l("INDEX.tips_tech_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.tips_tech_product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api.ecomAmzSkuDocDelApi({ amzSkuDocCode: code }).then((res) => {
          if (res.status === 200) {
            this.$message({
              showClose: true,
              message: res.msg || this.$l("INDEX.tips_delete_ok") || "删除成功",
              type: "success",
            });
            this.$emit("reload");
          }
        });
      });
    },
  },
};
</script>
